import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlert } from 'foundations-components/transitional/components/FloatingAlert';
import { useDispatch } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { fetchExistingAccounts } from '../store/existing-accounts/action-creators';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http/HttpRequester';
import { useEffect, useState } from 'react';
import { useExistingAccounts } from './useExistingAccounts';
import { useTracker } from '../tracking/useTracker';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExistingAccountsErrorModal = () => {
  const dispatch = useDispatch();
  const {
    hubsFailedToLoad,
    fetching,
    fetchError
  } = useExistingAccounts();
  const [shouldShow, setShouldShow] = useState(false);
  const [closed, setClosed] = useState(false);
  const Tracker = useTracker();
  useEffect(() => {
    if (shouldShow !== hubsFailedToLoad && !fetching && !closed && !fetchError) {
      setShouldShow(hubsFailedToLoad);
    }
  }, [hubsFailedToLoad, shouldShow, fetching, closed, fetchError]);
  useEffect(() => {
    if (shouldShow) {
      Tracker.signupInteraction('existing-accounts-error-modal-shown');
    }
  }, [shouldShow, Tracker]);
  const handleLinkClick = () => {
    Tracker.signupInteraction('existing-accounts-error-modal-retry');
    setShouldShow(false);
    dispatch(fetchExistingAccounts()).catch(error => {
      LOG.error('Error retrying fetching existing user accounts', {
        extra: getSentryExtra(error)
      });
    });
  };
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    margin: "auto",
    children: /*#__PURE__*/_jsxs(FloatingAlert, {
      type: "warning",
      onClose: () => {
        Tracker.signupInteraction('existing-accounts-error-modal-close');
        setClosed(true);
        setShouldShow(false);
      },
      children: [/*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.ExistingAccounts}.errorModal.text`
        })
      }), /*#__PURE__*/_jsx(Link, {
        marginInlineStart: "300",
        onClick: handleLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.ExistingAccounts}.errorModal.retry`
        })
      })]
    })
  });
};
export default ExistingAccountsErrorModal;